<div class="row file-list" *ngIf="internalList.length > 0">
  <div
    class="d-flex flex-row justify-content-between align-items-center"
    *ngFor="let file of internalList">
    <div data-test="file" class="file-name">
      <i
        [ngClass]="[
          'bi',
          'bi-file-richtext',
          'color-tertiary',
          'fs-21',
          'me-1',
          'd-inline-block'
        ]"></i>
      <span title="{{ file.title }}">{{ file.title }}</span>
    </div>
    <div class="d-flex align-items-center">
      <button
        ngbTooltip="View file"
        aria-label="View file"
        class="btn"
        (click)="viewFile(file)">
        <i [ngClass]="['bi', 'fs-21', 'bi-eye']"></i>
      </button>
      <button
        aria-label="Delete course file button"
        type="button"
        class="btn-delete"
        [autoClose]="'outside'"
        [ngbPopover]="deleteCourseFile"
        [popoverTitle]="'Delete course file'"
        [autoClose]="'outside'"
        #popover="ngbPopover">
        <i [ngClass]="['bi', 'fs-21', 'bi-trash']"></i>
      </button>
      <ng-template #deleteCourseFile>
        Are you sure you want to delete this course file?
        <div class="text-end mt-2">
          <button
            type="button"
            class="btn btn-secondary btn-sm px-3 m-1"
            (click)="popover.close()">
            No
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm px-3 m-1"
            (click)="deleteFile(file); popover.close()">
            Yes
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<ng-container *ngIf="errorMessage">
  <div
    class="alert alert-danger text-start d-flex justify-content-between mt-3 mb-0"
    role="alert">
    {{ errorMessage }}
    <button
      type="button"
      class="btn-close"
      (click)="errorMessage = ''"
      data-bs-dismiss="alert"
      aria-label="Close"></button>
  </div>
</ng-container>
